<template>
  <v-container fill-height fluid>
  <v-row class="text-center" justify="center">
  <v-col cols="12" style="max-width: 780px;">

    <div class="d-none d-sm-flex" style="height:64px;"></div>

    <!---- MAGIO GO ---->
    <div v-if="tenant == 'GO' || tenant == 'TMCZ_GO'">
      <p class="mb-1 heading1">{{ print('PARTNER.VOYO.SSO_WEB.HOW_TO_LOGIN.TITLE') }}</p>
      <p class="mb-1 text1">{{ print('PARTNER.VOYO.SSO_WEB.HOW_TO_LOGIN.TITLE_DESCRIPTION') }}</p>

      <p class="mb-1 heading3go">{{ print('PARTNER.VOYO.SSO_WEB.HOW_TO_LOGIN.SUBTITLE1_TITLE') }}</p>
      <div class="mt-5 mb-5" v-if="print('PARTNER.VOYO.SSO_WEB.HOW_TO_LOGIN.SUBTITLE1_TITLE').length > 3">
        <v-img contain :src="require('@/assets/howto/magio_app_icon.png')" alt="Magio App Logo" width="45" height="45" style="float: left; margin-right: 10px;" />
        <v-img contain :src="require('@/assets/howto/voyo_app_icon.png')" alt="Voyo App Logo" width="45" height="45" style="float: left; margin-right: 15px;" />
        <p class="mb-1 text1" v-html="print('PARTNER.VOYO.SSO_WEB.HOW_TO_LOGIN.SUBTITLE1_DESCRIPTION')"></p>
      </div>
      <div class="frame1 pa-4" v-if="print('PARTNER.VOYO.SSO_WEB.HOW_TO_LOGIN.SUBTITLE1_TITLE').length > 3">
        <p class="mb-1 text2" style="color: #A4A4A4;" v-html="print('PARTNER.VOYO.SSO_WEB.HOW_TO_LOGIN.SUBTITLE1_TEXT')">
          <!--span style="font-weight: bold;">Nepamätáte si prihlasovacie údaje do Magio GO?</span>
          <ul>
            <li class="mt-1">prihlasovacie meno do Magio GO nájdete na svojej Telekom faktúre</li>
            <li class="mt-1">zabudnuté heslo do Magio GO si viete jednoducho zmeniť prostredníctvom tlačidla "Zabudnuté heslo" na tejto stránke s prihlásením alebo priamo v aplikácii Magio GO</li>
          </ul-->
        </p>
      </div>

      <p class="mb-1 heading3go">{{ print('PARTNER.VOYO.SSO_WEB.HOW_TO_LOGIN.SUBTITLE2_TITLE') }}</p>
      <div class="mt-5 mb-5" v-if="print('PARTNER.VOYO.SSO_WEB.HOW_TO_LOGIN.SUBTITLE2_TITLE').length > 3">
        <v-img contain :src="require('@/assets/howto/voyo_app_icon.png')" alt="Voyo App Logo" width="45" height="45" style="float: left; margin-right: 15px;" />
        <p class="mb-1 text1" v-html="print('PARTNER.VOYO.SSO_WEB.HOW_TO_LOGIN.SUBTITLE2_DESCRIPTION')"></p>
      </div>
      <div class="frame1 pa-4" v-if="print('PARTNER.VOYO.SSO_WEB.HOW_TO_LOGIN.SUBTITLE2_TITLE').length > 3">
        <p class="mb-1 text2" style="color: #A4A4A4;" v-html="print('PARTNER.VOYO.SSO_WEB.HOW_TO_LOGIN.SUBTITLE2_TEXT')">
          <!--span style="font-weight: bold; letter-spacing: 1px;">Nepamätáte si prihlasovacie údaje do Voyo?</span>
          <ul>
            <li class="mt-1">prihlasovacie údaje do Voyo si viete dohľadať vo svojej e-mailovej schránke, prípadne medzi prijatými SMS správami, ktoré ste obdržali pri aktivácii služby Voyo v Telekome</li>
          </ul-->
        </p>
      </div>
    </div>

    <!---- DIGI GO ---->
    <div v-if="tenant == 'DIGI'">
      <p class="mb-1 heading1">{{ print('PARTNER.VOYO.SSO_WEB.HOW_TO_LOGIN.TITLE') }}</p>
      <p class="mb-1 text1">{{ print('PARTNER.VOYO.SSO_WEB.HOW_TO_LOGIN.TITLE_DESCRIPTION') }}</p>

      <p class="mb-1 heading3digi">{{ print('PARTNER.VOYO.SSO_WEB.HOW_TO_LOGIN.SUBTITLE1_TITLE') }}</p>
      <div class="mt-5 mb-5">
        <v-img contain :src="require('@/assets/howto/voyo_app_icon.png')" alt="Voyo App Logo" width="45" height="45" style="float: left; margin-right: 15px;" />
        <p class="mb-1 text1" v-html="print('PARTNER.VOYO.SSO_WEB.HOW_TO_LOGIN.SUBTITLE1_DESCRIPTION')"></p>
      </div>
      <div class="frame1 pa-4">
        <p class="mb-1 text2" style="color: #A4A4A4;" v-html="print('PARTNER.VOYO.SSO_WEB.HOW_TO_LOGIN.SUBTITLE1_TEXT')">
          <!--span style="font-weight: bold; letter-spacing: 1px;">Nepamätáte si prihlasovacie údaje do Voyo?</span>
          <ul>
            <li class="mt-1">prihlasovacie údaje do Voyo si môžete dohľadať v e-maile, ktorý sme vám poslali pri aktivácií služby Voyo cez DIGI SLOVAKIA alebo ho nájdete vo vašom <a href="https://ekonto.digislovakia.sk" target="_blank">e-konte</a> v sekcii „Služby“</li>
            <li class="mt-1">zabudnuté heslo do Voyo si viete jednoducho zmeniť prostredníctvom tlačidla "Zabudnuté heslo" na <a href="/resetpass">tejto stránke</a></li>
          </ul-->
        </p>
      </div>

      <p class="mb-1 heading3digi">{{ print('PARTNER.VOYO.SSO_WEB.HOW_TO_LOGIN.SUBTITLE2_TITLE') }}</p>
      <div class="mt-5 mb-5">
        <v-img contain :src="require('@/assets/howto/digigo_app_icon.png')" alt="DigiGo App Logo" width="45" height="45" style="float: left; margin-right: 10px;" />
        <v-img contain :src="require('@/assets/howto/voyo_app_icon.png')" alt="Voyo App Logo" width="45" height="45" style="float: left; margin-right: 15px;" />
        <p class="mb-1 text1" v-html="print('PARTNER.VOYO.SSO_WEB.HOW_TO_LOGIN.SUBTITLE2_DESCRIPTION')"></p>
      </div>
      <div class="frame1 pa-4">
        <p class="mb-1 text2" style="color: #A4A4A4;" v-html="print('PARTNER.VOYO.SSO_WEB.HOW_TO_LOGIN.SUBTITLE2_TEXT')">
          <!--span style="font-weight: bold;">Nepamätáte si prihlasovacie údaje do DIGI GO?</span>
          <ul>
            <li class="mt-1">prihlasovacie meno do DIGI GO nájdete v <a href="https://ekonto.digislovakia.sk" target="_blank">e-konte</a> v sekcii "Služby"</li>
            <li class="mt-1">zabudnuté heslo do DIGI GO si viete jednoducho zmeniť prostredníctvom tlačidla "Zabudnuté heslo" na <a href="/resetpass">tejto stránke</a> alebo priamo v aplikácii DIGI GO</li>
          </ul-->
        </p>
      </div>
    </div>

    <v-row justify="center">
        <v-col cols="12" sm="2" class="pt-10 pb-5">
            <v-btn block x-large color="secondary" @click="goBack"
                style="text-transform: none; color: #EBEBEB; font-size: 18px"
            >
                {{ print('PARTNER.VOYO.SSO_WEB.CLOSE_BTN') }}
            </v-btn>
        </v-col>
    </v-row>

  </v-col>
  </v-row>
  </v-container>
</template>

<style>
  .heading1 {
      text-align: left;
      font-size: 30px;
      line-height: 1.2;
      letter-spacing: 1px;
      color: #EBEBEB;
  }
  .heading3go {
    text-align: left;
    font-size: 24px;
    line-height: 1.2;
    color: #E20074;
    font-weight: bold;
    margin-top: 36px;
    letter-spacing: 0px;
  }
  .heading3digi {
    text-align: left;
    font-size: 24px;
    line-height: 1.2;
    color: #0095DA;
    font-weight: bold;
    margin-top: 36px;
    letter-spacing: 0px;
  }
  .text1 {
      text-align: left;
      font-size: 18px;
      line-height: 1.2;
      letter-spacing: 0.7px;
      color: #EBEBEB;
  }
  .text2 {
      text-align: left;
      font-size: 18px;
      line-height: 1.2;
      letter-spacing: 0.7px;
      color: #A4A4A4;
  }
  .frame1 {
    border: 1px solid #707070;
  }
  
  .links a {
    color: #00A0DE;
    font-size: 18px
  }
  
  .links a.router-link-exact-active {
    color: #00A0DE;
  }
  
  .links a:link, a:visited {
    color: #00A0DE;
    text-decoration: none;
  }
  
  .links a:hover, a:active {
    color: #00A0DE;
    text-decoration: none;
  }
  
  .v-text-field {
      font-size: 1.5em;
      font-weight: 100;
  }
  
  .v-btn {
      text-transform: none;
      color: #EBEBEB;
      font-size: 1.5em !important;
      letter-spacing: normal;
  }
  
  </style>

<script>
  import { api } from "../main";
  import VueCookies from 'vue-cookies'

  export default {
    name: 'HowTo',

    components: {
    },

    data: () => ({
    }),

    props: ['languagestrings', 'toperror'],

    computed: {
      flowType() {
        var flowType = VueCookies.get('flow');
        //console.log('flowType', flowType);
        return flowType;
      },
      tenant() {
        return VueCookies.get('tenant');
      }
    },

    methods: {
        goBack() {
            this.$router.go(-1)
        },
        print(input_prop) {
            return api.print(this.languagestrings, input_prop);
        },
    }
  }
</script>